<template>
    <div v-if="!loading">
        <slot name="dialog"></slot>
        <v-btn test-tag="tag-6" v-for="(btn,n) in displayBtns" :key="n" 
            :color="btn.color" 
            class="mr-3"
            @click="changeStatus(btn.name)"
        >
            <T>{{ btn.text }}</T>
        </v-btn>
    </div>
    <div v-else>
        <v-tooltip bottom>
            <template v-slot:activator="{on, attrs}">
                <v-progress-circular indeterminate v-bind="attrs" v-on="on"/>
            </template>
            <span>{{ $t(sync_status.text) }}</span>
        </v-tooltip>
    </div>
</template>

<script>

export default{
    props:{
       btns: Array,
       active_status: String,
       sync_status: Object
    },
    data: ()=>({
    }),
    computed:{
        loading(){ 
            return this.active_status != "NEW" && this.sync_status.name == "WAIT" 
        },
        displayBtns(){
            return this.btns.map(btn => {
                if (this.active_status === "WAIT_PAY" && btn.name === "COOKING") {
                    return {
                        ...btn,
                        text: "Оплатить"
                    }
                }
                return btn
            })
        }
    },
    methods:{
        changeStatus(status){
            this.$emit('changeStatus', status)
        }
    },
    mounted(){
    }
}
</script>